<template>
  <div :class="classes()">
    <template v-if="careServiceWizardIsFinished">
      <div :class="`${el}__row`">
        <Copy element="div" size="xl" bold centered>
          {{ $t('cs.analysis.budgetPackage.recommendation.headline') }}
        </Copy>
        <div :class="`${el}__inner`">
          <Copy element="div" size="l" bold centered responsive>
            {{ $t('cs.analysis.budgetPackage.recommendation.row1.headline') }}
          </Copy>

          <Row class="u-margin__top--6" verticalCenter>
            <Col
              :xs="12"
              :m="6"
              :l="4"
              :class="`${el}__recommendation--pflegegeld`"
              :hasMargin="!$matchMedia.l"
            >
              <Copy :right="$matchMedia.l" :centered="!$matchMedia.l" element="div">
                {{ $t('cs.analysis.budgetPackage.recommendation.pflegegeld') }}
              </Copy>
              <Copy
                element="div"
                size="l"
                color="primaryCoral"
                :right="$matchMedia.l"
                :centered="!$matchMedia.l"
                bold
              >
                {{ $t('cs.analysis.budgetPackage.recommendation.row1.pflegegeld') }}
              </Copy>
              <Copy
                element="div"
                size="l"
                color="primaryCoral"
                :right="$matchMedia.l"
                :centered="!$matchMedia.l"
                bold
              >
                {{ formatNumber(calculatedBasics.pflegegeld.amount, 0) }} €
              </Copy>
            </Col>
            <Col
              :xs="10"
              :xsOffset="1"
              :m="6"
              :mOffset="3"
              :l="4"
              :lOffset="0"
              :class="`${el}__recommendation--chart`"
              center
              :hasMargin="!$matchMedia.l"
            >
              <Doughnut
                :width="230"
                :height="230"
                :chartData="{
                  labels: [
                    $t('cs.analysis.budgetPackage.recommendation.pflegesachleistungen'),
                    $t('cs.analysis.budgetPackage.recommendation.pflegegeld'),
                  ],
                  datasets: [
                    {
                      data: [
                        calculatedBasics.pflegesachleistungen.amount,
                        calculatedBasics.pflegegeld.amount,
                      ],
                      backgroundColor: [colors.primaryBlue, colors.primaryCoral],
                      hoverOffset: 4,
                      hoverBackgroundColor: [colors.primaryBlue, colors.primaryCoral],
                    },
                  ],
                }"
                :options="chartOptions"
              />
            </Col>
            <Col
              :xs="12"
              :m="6"
              :l="4"
              :class="`${el}__recommendation--pflegesachleistungen`"
              :hasMargin="!$matchMedia.l"
            >
              <Copy :centered="!$matchMedia.l" element="div">
                {{ $t('cs.analysis.budgetPackage.recommendation.pflegesachleistungen') }}
              </Copy>
              <Copy :centered="!$matchMedia.l" element="div" size="l" color="primaryBlue" bold>
                {{ $t('cs.analysis.budgetPackage.recommendation.row1.pflegesachleistungen') }}
              </Copy>
              <Copy :centered="!$matchMedia.l" element="div" size="l" color="primaryBlue" bold>
                {{ formatNumber(calculatedBasics.pflegesachleistungen.amount, 0) }} €
              </Copy>
            </Col>
          </Row>
        </div>
        <div :class="`${el}__teaser`">
          <div :class="`${el}__teaserInner`">
            <Copy element="div" color="tertiaryLight">
              {{ $t(`cs.analysis.budgetPackage.recommendation.row2.subline.${ourRecommendation}`) }}
            </Copy>
            <Copy element="div" size="l" bold>
              {{
                $t(`cs.analysis.budgetPackage.recommendation.row2.headline.${ourRecommendation}`)
              }}
            </Copy>
            <Copy staticClass="u-margin__top--2" element="div">
              {{ $t(`cs.analysis.budgetPackage.recommendation.row2.copy.${ourRecommendation}`) }}
            </Copy>
            <Link
              class="u-margin__top--2"
              :onClick="() => openContentSheet()"
              icon="arrow-right-line"
              iconPos="right"
            >
              {{ $t('cs.wizard.switcherToggle.link') }}
            </Link>
          </div>
          <div :class="`${el}__price`">
            {{
              $t('cs.analysis.generals.monthly', {
                value: formatNumber(
                  calculatedBasics.pflegegeld.amount + calculatedBasics.pflegesachleistungen.amount,
                  0
                ),
              })
            }}
            <br />
            {{
              $t('cs.analysis.generals.yearly', {
                value: formatNumber(
                  (calculatedBasics.pflegegeld.amount +
                    calculatedBasics.pflegesachleistungen.amount) *
                    12,
                  0
                ),
              })
            }}
          </div>
        </div>
      </div>
      <!-- <div :class="`${el}__row ${el}__row--centered`">
        <Label
          :label="$t('cs.analysis.budgetPackage.recommendation.toggle.tag')"
          size="m"
          bold
          color="supportSuccess"
        />
        <Headline size="xs" centered>
          {{ $t('cs.analysis.budgetPackage.recommendation.toggle.headline') }}
        </Headline>
        <ToggleSwitch
          class="u-margin__top--3"
          :inactiveLabel="$t('cs.analysis.budgetPackage.recommendation.toggle.inactiveLabel')"
          :activeLabel="$t('cs.analysis.budgetPackage.recommendation.toggle.activeLabel')"
          :checked="usingRecommendation"
          @click="usingRecommendation = !usingRecommendation"
          :labelOnSamePosition="!$matchMedia.l"
        />
      </div> -->
    </template>
    <div v-else :class="`${el}__row`">
      <Copy element="div" size="l" bold centered responsive>
        {{ $t('cs.analysis.budgetPackage.recommendation.noWizard.headline') }}
      </Copy>
      <div class="u-textAlign--center u-margin__top--3">
        <Button
          :href="ROUTE_SERVICE_PFLEGELEISTUNGSFINDER"
          :label="$t('cs.analysis.cat.widget.noWizard.link')"
          additionalIconName="pencil-line"
          additionalIconPos="left"
          small
        />
      </div>
    </div>
  </div>
</template>

<script>
import Copy from '@/objects/Copy';
import Link from '@/objects/Link';
import Button from '@/objects/Button';
// import Label from '@/objects/Label';
// import Headline from '@/objects/Headline';
// import ToggleSwitch from '@/objects/ToggleSwitch';
import Doughnut from '@/components/Charts/Doughnut';
import Row from '@/components/Grid/Row';
import Col from '@/components/Grid/Col';

import { CONTENT_SHEET_CONTENT } from '@/store/actions/contentSheet';
import { ROUTE_SERVICE_PFLEGELEISTUNGSFINDER } from '@/constants/routes';

import mixin from '@/mixins/careService';

import colors from '@/styles/base/_colors.scss';

import { formatNumber } from '@/helpers/formatter';

export default {
  name: 'CareServiceBudgetRecommendation',
  props: {},
  mixins: [mixin],
  components: {
    Copy,
    Link,
    Button,
    Doughnut,
    Row,
    Col,
    // Label,
    // Headline,
    // ToggleSwitch,
  },
  data() {
    return {
      ROUTE_SERVICE_PFLEGELEISTUNGSFINDER,
      el: 'c-careServiceBudgetRecommendation',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
        };
      },
      colors,
      chartOptions: {
        cutoutPercentage: 70,
        responsive: true,
        title: {
          display: false,
        },
        legend: {
          display: false,
        },
        tooltips: {
          callbacks: {
            label(c, d) {
              const label = d.labels[c.index] || '';
              const formattedValue = d.datasets[0].data[c.index] || '';
              return `${label}: ${formatNumber(formattedValue, 0)} € / Monat`;
            },
          },
        },
        hover: { mode: null },
      },
    };
  },
  methods: {
    openContentSheet() {
      this.$store.dispatch(CONTENT_SHEET_CONTENT, {
        sheetId: `pflegeleistungen/${this.ourRecommendation}`,
      });
    },
  },
};
</script>
